import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import Elliott from "../../../assets/img/blog/25maple/Elliott.webp"; 
import Elsies from "../../../assets/img/blog/25maple/Elsies.webp"; 
import Richardsons from "../../../assets/img/blog/25maple/Richardsons.webp";
import Muskoka from "../../../assets/img/blog/25maple/Muskoka.avif"; 

import mapleSyrup01 from "../../../assets/img/blog/qc/mapleSyrup01.webp"; 
import mapleSyrup02 from "../../../assets/img/blog/qc/mapleSyrup02.webp"; 
import mapleSyrup03 from "../../../assets/img/blog/qc/mapleSyrup03.webp"; 


const MAPLE_REGIONS = [
  {
    id: "montreal",
    region: "Montreal Region",
    farms: [
      {
        name: "Sucrerie de la Montagne",
        img: mapleSyrup01,
        description: "One of Quebec’s most famous traditional sugar shacks, offering horse-drawn wagon rides, live folk music, and classic maple feasts cooked using historic wood-fired methods.",
        location: "300, Chemin St-Georges, Rigaud, Qc, Canada J0P 1P0",
        website: "Sucrerie de la Montagne",
        webUrl: "https://www.sucreriedelamontagne.com/",
        dates: "Feb 21 – May 3, 2026"
      },
      {
        name: "Cabane à Sucre Constantin",
        description: "One of the largest sugar shacks near Montreal featuring traditional meals, horse-drawn wagon rides, and maple taffy.",
        location: "1054 Bd Arthur-Sauvé, Saint-Eustache, QC J7R 4K3",
        website: "Cabane à Sucre Constantin",
        webUrl: "https://constantin.ca/",
        dates: "Late February – April, 2026"
      },
      {
        name: "Cabane à Sucre D'Amours",
        description: "A traditional family sugar shack offering classic Quebec maple meals, taffy on snow, and views of the countryside maple forests.",
        location: "427 5e Ave, Sainte-Anne-des-Plaines, QC J5N 0H7",
        website: "Cabane à Sucre D'Amours",
        webUrl: "https://damours.ca/",
        dates: "February - April, 2026"
      },
      {
        name: "Lalande",
        description: "A classic Quebec sugar shack experience known for generous maple feasts and a lively family-friendly atmosphere.",
        location: "862 Montée Laurin, Saint-Eustache, Québec, J7R 0J2",
        website: "Lalande",
        webUrl: "https://www.lalande.ca/",
        dates: "Late February – April"
      }
    ]
  },
  {
    id: "qc",
    region: "Quebec City Region",
    farms: [
      {
        name: "Érablière du Lac‑Beauport",
        img: mapleSyrup02,
        description: "A popular sugar shack near Quebec City, known for traditional maple meals, family-friendly activities, and scenic maple forest surroundings.",
        location: "200 Chem. des Lacs, Lac-Beauport, QC G3B 1C4",
        website: "Fort Rose Maple Company",
        webUrl: "https://erablierelacbeauport.com",
        dates: "late Feb – mid Apr, 2026"
      },
      {
        name: "Sucrerie Blouin",
        description: "A well-known maple farm on Île d’Orléans offering authentic Quebec sugar shack meals and demonstrations of maple syrup production.",
        location: "4315 Chem. Royal, Saint-Jean-de-l'Île-d'Orléans, QC G0A 3W0",
        website: "Sucrerie Blouin",
        webUrl: "https://www.sucrerieblouin.com/",
        dates: "March – April, 2026"
      },
      {
        name: "Érablière le Chemin du Roy",
        description: "A classic Quebec sugar shack experience featuring maple syrup tastings, traditional dishes, and rustic dining rooms.",
        location: "237 Chem. du Lac, Saint-Augustin-de-Desmaures, QC G2G 0C6",
        website: "Érablière le Chemin du Roy",
        webUrl: "https://blythcreekmaplefarm.com/",
        dates: "March – April, 2026"
      },
      {
        name: "Le Relais des Pins",
        description: "A lively sugar shack known for traditional maple meals, live music, dancing, and classic Quebec hospitality.",
        location: "2013 Chem. Royal, Sainte-Famille, QC G0A 3P0",
        website: "Le Relais des Pins",
        webUrl: "https://www.lerelaisdespins.com/?__cf_chl_tk=XgibtchD12F34YydqC2Hr.8rXfhshi5lLxGEMWUHRbs-1772737389-1.0.1.1-lalKCUdsDhNnNSY_0ePmyzu5SBz43vE4NWnXp0QKsDs",
        dates: "March – April (some services year-round), 2026"
      },
      {
        name: "La Cité Agricole",
        description: "An agricultural experience center where visitors can learn about local farming traditions, including maple syrup production and seasonal tastings.",
        location: "4260 Chemin Notre Dame, Saint-Augustin-de-Desmaures, QC G3A 1W8",
        website: "La Cité Agricole",
        webUrl: "https://citeagricole.com/",
        dates: "Seasonal maple experiences in spring (varies annually)"
      },
      {
        name: "Cabane à Sucre Chabot",
        description: "A traditional family-run sugar shack offering hearty Quebec maple meals, maple taffy on snow, and live music during the sugaring season.",
        location: "800 2e Rang, Neuville, QC G0A 2R0",
        website: "Cabane à Sucre Chabot",
        webUrl: "https://cabanechabot.com/",
        dates: "Feb – April, 2026"
      },
      {
        name: "La Cabane Festive",
        description: "A festive maple-themed event with traditional food, music, and maple treats celebrating Quebec’s sugaring season.",
        location: "6 Chem. du Geai Bleu, Sainte-Christine-d'Auvergne, QC G0A 1A0",
        website: "La Cabane Festive",
        webUrl: "https://cabanefestive.com/",
        dates: "Seasonal pop-up during maple season (usually March)"
      }
    ]
  },
  {
    id: "laurentians",
    region: "Laurentians",
    farms: [
      {
        name: "Cabane à Sucre Bouvrette",
        img: Richardsons,
        description: "A popular sugar shack in the Laurentians known for maple taffy on snow, traditional meals, and family activities.",
        location: "1000 Rue Nobel, Saint-Jérôme, QC J7Z 7A3",
        website: "Cabane à Sucre Bouvrette",
        webUrl: "https://www.bouvrette.ca/",
        dates: "February – April, 2026"
      },
      {
        name: "Au Chalet en Bois Rond",
        description: "A rustic maple experience combining chalet lodging with traditional sugar shack meals and maple syrup tastings.",
        location: "325 Rang St Jacques, Sainte-Christine-d'Auvergne, QC G0A 1A0",
        website: "Au Chalet en Bois Rond",
        webUrl: "https://www.auchaletenboisrond.com/?utm_source=google&utm_medium=GPE",
        dates: "Spring maple season (varies)"
      }
    ]
  },
  {
    id: "southshore-montreal",
    region: "Montérégie Region (South Shore of Montreal) ",
    farms: [
      {
        name: "Érablière Charbonneau",
        img: Elliott,
        description: "One of Quebec’s most family-friendly maple farms, offering wagon rides, orchard visits, and traditional sugar shack dining.",
        location: "45 Chem. du Sous-Bois, Mont-Saint-Grégoire, QC J0J 1K0",
        website: "Érablière Charbonneau",
        webUrl: "https://www.erablierecharbonneau.qc.ca/fr/erabliere",
        date: "Feb – April, 2026"
      },
      {
        name: "Domaine de l’Érable",
        description: "A charming maple farm where visitors can enjoy authentic Quebec maple meals and learn about traditional syrup production.",
        location: "5760 Rang des Érables, Saint-Hyacinthe, QC J2R 2A3",
        website: "Domaine de l’Érable",
        date: "March – April, 2026"
      },
      {
        name: "Érablière Meunier",
        description: "A historic maple farm offering authentic Quebec cuisine, maple tastings, and traditional sugaring demonstrations.",
        location: "325 Rang des Cinquante-Quatre, Richelieu, QC J3L 6R5",
        website: "Érablière Meunier",
        webUrl: "https://erablieremeunier.com/",
        date: "March – April, 2026"
      },
      {
        name: "La Cabane du Coureur",
        description: "A refined “gourmet sugar shack” experience blending traditional maple dishes with modern Quebec cuisine.",
        location: "158 Rang des Soixante, Saint-Marc-sur-Richelieu, QC J0L 2E0",
        website: "La Cabane du Coureur",
        webUrl: "https://cabaneducoureur.ca/en/home/",
        date: "March – April (reservation recommended)"
      },
      {
        name: "Cabane à Sucre Handfield",
        description: "A traditional sugar shack in the Montérégie region offering a rustic countryside atmosphere, classic Quebec maple meals, and seasonal maple menu experiences with tastings and live music during the sugaring season.",
        location: "190 Rang des Soixante, Saint-Marc-sur-Richelieu, QC J0L 2E0",
        website: "Cabane à Sucre Handfield",
        webUrl: "https://www.aubergehandfield.com/fr/la-cabane/",
        date: "February – April, 2026"
      },
      {
        name: "Érablière Au Palais Sucré",
        description: "A well-known family sugar shack offering traditional maple meals, taffy on snow, and guided tours explaining maple syrup production.",
        location: "864 Rang Chartier, Mont-Saint-Grégoire, QC J0J 1K0",
        website: "Érablière Au Palais Sucré",
        webUrl: "https://aupalaissucre.ca/",
        date: "February – April, 2026"
      }
    ]
  },
  {
    id: "mauricie",
    region: "Mauricie",
    farms: [
      {
        name: "Cabane à Sucre Chez Dany",
        img: Muskoka,
        description: "A charming family sugar shack known for its traditional maple cuisine and welcoming countryside setting.",
        location: "195 Rue de la Sablière, Trois-Rivières, QC G9B 7A9",
        website: "Cabane à Sucre Chez Dany",
        webUrl: "https://cabanechezdany.com/",
        dates: "March – April, 2026"
      }
    ]
  }

];

export default function MapleSyrupQC() {
  return (
    <div className={styles.page}>
      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Travel</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti Team</span>
        <span className={styles["sep"]}>•</span>
        <span>February 11, 2025</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>Best Maple Syrup Farms in Quebec (2026 Guide)</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={mapleSyrup03}
          alt="Maple Syrup Festival"
        />
      </div>

    <div className={styles["lead-section"]}>
        
    <p><strong>Step into Quebec’s sweetest spring tradition!</strong><br />
      As winter begins to fade and the maple trees awaken, maple syrup farms in Quebec, also known locally as <em>cabane à sucre</em>, open their doors across the province. This beloved seasonal tradition celebrates the harvest of maple sap and its transformation into Canada’s most iconic treat: pure maple syrup.</p>

    <p>
      Visitors to a maple farm in Quebec can experience the magic of the sugaring season firsthand—from watching maple sap collected and boiled into syrup to enjoying hearty traditional meals served inside cozy wooden cabins. Classic sugar shack dishes often include maple-glazed ham, baked beans, fluffy pancakes, and, of course, maple taffy poured over fresh snow.
    </p>

    <p>
      Beyond the food, many maple syrup farms in Quebec City offer outdoor activities, horse-drawn sleigh rides, live folk music, and guided tours through the maple forest, making it a perfect spring outing for families, friends, and visitors looking to experience authentic Quebec culture.
    </p>

    <p>
      Ready to explore? We’ve rounded up some of the best maple syrup across Quebec, where you can enjoy the unforgettable flavors and traditions of the 2026 sugaring season.
    </p>

    <p><strong>🗓 Sugaring Season:</strong> Late February to Late April 2026<br />
      Bring your appetite and get ready to experience one of Canada’s most delicious spring traditions!</p>
    </div>

      <div className={styles["jump-links"]}>
        {MAPLE_REGIONS.map((region, idx) => (
          <React.Fragment key={region.id}>
            <a href={`#${region.id}`}>{region.region}</a>
            {idx < MAPLE_REGIONS.length - 1 && <span> | </span>}
          </React.Fragment>
        ))}
      </div>

      {MAPLE_REGIONS.map((region) => (
        <div key={region.id} id={region.id}>
          <h2 className={styles["region-title"]}>{region.region}</h2>
          <hr className={styles["region-divider"]} />
          
          {region.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
              
              <div className={styles["farm-description"]}>
                <p>{farm.description}</p>
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Location:</span> {farm.location}
                </li>
                {farm.dates && (
                    <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Dates:</span> {farm.dates}
                    </li>
                )}
                {farm.website && (
                  <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Website:</span><br />
                    <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                      {farm.website}
                    </a>
                  </li>
                )}
              </ul>
              <hr className={styles["farm-divider"]} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
